<template>
  <div class="d-flex">
    <b-select v-model="currentValue" :options="options" size="sm" @input="valueChange"></b-select>
  </div>
</template>

<script>
export default {
  name: 'BooleanFloatingFilter',
  data () {
    return {
      currentValue: null,
      options: [
        {value: null, text: ''},
        {value: true, text: 'Marcados'},
        {value: false, text: 'Desmarcados'}
      ]
    }
  },
  methods: {
    valueChange (value) {
      if (this.currentValue === null) {
        // Remove the filter
        this.params.parentFilterInstance((instance) => {
          instance.onFloatingFilterChanged(null, null)
        })
        return
      }

      this.params.parentFilterInstance((instance) => {
        instance.onFloatingFilterChanged('equals', this.currentValue)
      })
    }
  }
}
</script>

<style scoped>
* >>> .custom-select {
  padding: 0;
  height: 15px;
  font-size: inherit;
}

div {
  width: 100%;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/BooleanFloatingFilter.vue